import { useEffect } from "react";

function TallyEmbed() {
  useEffect(() => {
    const scriptSrc = "https://tally.so/widgets/embed.js";

    const loadScript = () => {
      if (window.Tally) {
        window.Tally.loadEmbeds();
      }
    };

    if (!window.Tally) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.onload = loadScript;
      script.onerror = loadScript;
      document.head.appendChild(script); // Append to <head> for faster loading
    } else {
      loadScript();
    }
  }, []);

  return (
    <div className="tally-embed-container">
      <iframe
        src="https://tally.so/embed/wvpqGv?hideTitle=1&dynamicHeight=1&transparentBackground=1"
        height="926"
        title="DataPulse: Get in touch!"
        width="100%"
      ></iframe>
    </div>
  );
}

export default TallyEmbed;
